

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from './StudyManagement.module.css';

// const StudyManagement = () => {
//     const navigate = useNavigate();

//     return (
//         <div className={styles.page}>
//             <div className={styles.header}>
//                 <h1 className={styles.title}>Study Management</h1>
//             </div>

//             <div className={styles.card}>
//                 <h2>Available Studies</h2>

//                 {/* Add buttons to navigate to surveys */}
//                 <div style={{ display: 'flex', gap: '10px', marginTop: '20px', alignItems: 'center', justifyContent: 'center' }}>
//                     <button
//                         onClick={() => navigate('/survey/1')}
//                         className={styles.addButton}
//                     >
//                         Start Survey
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StudyManagement;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StudyManagement.module.css';
import { getStudy } from '../../Config/api';

const StudyManagement = () => {
    const navigate = useNavigate();
    const [surveyStatus, setSurveyStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Get userId from localStorage
    const getUserId = () => {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            return user.userId || user.user_id || user.id || null;
        } catch (error) {
            console.error('Error getting userId:', error);
            return null;
        }
    };

    const userId = getUserId();
    const studyId = 1; // Your study ID

    // Check survey status on component mount
    useEffect(() => {
        const checkSurveyStatus = async () => {
            if (!userId) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                const response = await getStudy(userId, studyId);
                const status = response?.data?.status;

                console.log('Survey status:', status);
                setSurveyStatus(status);
            } catch (error) {
                console.error('Error checking survey status:', error);
            } finally {
                setIsLoading(false);
            }
        };

        checkSurveyStatus();
    }, [userId]);

    const handleSurveyClick = () => {
        if (surveyStatus === 'submitted') {
            navigate('/survey/1');
        } else {
            navigate('/survey/1');
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <h1 className={styles.title}>Study Management</h1>
            </div>

            <div className={styles.card}>
                <h2>Available Studies</h2>

                <div style={{ display: 'flex', gap: '10px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    {isLoading ? (
                        <p>Loading...</p>
                    ) : surveyStatus === 'submitted' ? (
                        <>
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <div style={{ fontSize: '48px', color: '#22c55e', marginBottom: '10px' }}>✓</div>
                                <h3 style={{ color: '#22c55e', marginBottom: '10px' }}>Survey Completed</h3>
                                <p style={{ color: '#2f3237', marginBottom: '20px' }}>
                                    You have already submitted this survey. Thank you for your participation!
                                </p>
                                <button
                                    onClick={() => navigate('/survey/1')}
                                    className={styles.addButton}
                                    style={{ backgroundColor: '#22c55e' }}
                                >
                                    View Submission
                                </button>
                            </div>
                        </>
                    ) : surveyStatus === 'draft' ? (
                        <>
                            <p style={{ color: '#f59e0b', marginBottom: '10px' }}>
                                You have an active draft in progress.
                            </p>
                            <button
                                onClick={handleSurveyClick}
                                className={styles.addButton}
                            >
                                Continue Survey
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={handleSurveyClick}
                            className={styles.addButton}
                        >
                            Start Survey
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StudyManagement;